import Vue from 'vue'

export default {
    videoEvent(eventName, additionalDebugParams) {
        logEvent('video', eventName, additionalDebugParams)
        sendAppCuesEvent(eventName, additionalDebugParams)
    },

    navigationEvent(eventName, additionalDebugParams) {
        logEvent('navigation', eventName, additionalDebugParams)
        sendAppCuesEvent(eventName, additionalDebugParams)
    },

    actionEvent(eventName, additionalDebugParams) {
        logEvent('action', eventName, additionalDebugParams)
        sendAppCuesEvent(eventName, additionalDebugParams)
    }
}

function logEvent(eventCategory, eventName, additionalDebugParams) {
    Vue.$ga.event({
        eventCategory: eventCategory,
        eventAction: eventName,
        eventLabel: eventName,
        eventValue: additionalDebugParams
    })
}

function sendAppCuesEvent(eventName, additionalDebugParams) {
    console.log('sendAppCuesEvent', eventName, additionalDebugParams)
    if (window.Appcues) {
        window.Appcues.track(eventName, additionalDebugParams)
    }
}
